import { lazy } from "react";
const Home = lazy(() => import("./home/Home"));
const Login = lazy(() => import("./login/Login"));
const ForgotPassword = lazy(() => import("./forgot-password"));
const UserList = lazy(() => import("./users/UserList"));
const AddUser = lazy(() => import("./users/AddUser"));
const ChangePassword = lazy(() => import("./change-password/ChangePassword"));
const Prior = lazy(() => import("./prior/Prior"));
//const TrackOrder = lazy(() => import("./track-order/TrackOrder"));

// Profile Pages
const Profile = lazy(() => import("./profile/Profile"));
const EmailNotificationPermissions = lazy(
  () => import("./profile/EmailNotificationPermissions")
);

// Customer Management
const Customers = lazy(() => import("./customer-management/Customers/index"));
//const CustomerMarkupList = lazy(() => import("./customer-management/CustomerMarkup/index"));
//const AddEditCustomerMarkup = lazy(() => import("./customer-management/CustomerMarkup/CustomerMarkup"));
const AddCustomer = lazy(
  () => import("./customer-management/Customers/AddCustomer")
);
const CustomerUsers = lazy(() => import("./customer-management/CustomerUsers"));
const AddEditCustomerUsers = lazy(
  () => import("./customer-management/CustomerUsers/AddEditCustomerUsers")
);
const AddCustomerOfCustomer = lazy(
  () => import("./customer-management/Customers/Customers")
);
//const CustomerRate = lazy(() => import("./customer-management/CustomerRates"));
const CustomerRate = lazy(
  () => import("./customer-management/CustomerRateTabs")
);
const AddEditCustomerAdditionalCharges = lazy(
  () =>
    import(
      "./customer-management/CustomerRateTabs/CustomerAdditionalCharges/AddEditCustomerAdditionalCharges"
    )
);
const AddEditCustomerInvoiceGroups = lazy(
  () =>
    import(
      "./customer-management/CustomerRateTabs/CustomerInvoiceGroup/AddEditCustomerInvoiceGroups"
    )
);
const CustomerAddress = lazy(
  () =>
    import("./customer-management/CustomerAddressBook")
);
const CustomerAddressAdd = lazy(
  () =>
    import("./customer-management/CustomerAddressBook/AddEditCustomerAddress")
);

const ProvidenceLocationList = lazy(
  ()=> 
    import("./customer-management/CustomerRateTabs/LTLIntegrationsTab/Location/ProvidenceLocationList")
)
const AddEditLocation = lazy(
  () =>
    import(
      "./customer-management/CustomerRateTabs/LTLIntegrationsTab/Location/AddEditLocation"
    )
);
// Agent Management
const AgentList = lazy(() => import("./agent-management/AgentList/index"));
const AgentRequestList = lazy(() => import("./agent-management/AgentRequest/index"));
const AddEditAgentRequest = lazy(() => import("./agent-management/AgentRequest/AddEditAgentRequest"));
const AgentRate = lazy(() => import("./agent-management/AgentRate/index"));
const AddEditAgentList = lazy(
  () => import("./agent-management/AgentList/AddEditAgentList")
);
const AgentListTabs = lazy(
  () => import("./agent-management/AgentList/AgentListTabs")
);
const MasterAgentList = lazy(
  () => import("./agent-management/MasterAgentList")
);
const MasterAgentListTabs = lazy(
  () => import("./agent-management/MasterAgentList/MasterAgentListTabs")
);
const AgentHubs = lazy(() => import("./agent-management/AgentHubs/index"));
const AddEditAgentHub = lazy(
  () => import("./agent-management/AgentHubs/addEditAgentHub/index")
);
const AgentDocList = lazy(
  () => import("./agent-management/AgentDocList/index")
);

// Rep Management
const MyRepList = lazy(() => import("./rep-management/MyRepList/index"));
const AddEditSalesRep = lazy(
  () => import("./rep-management/AddEditSalesRep/index")
);
const AddEditAgentAdditionalCharges = lazy(
  () =>
    import(
      "./agent-management/AgentList/AgentListTabs/AgentAdditionalCharges/AddEditAgentAdditionalCharges"
    )
);

// Order Mangement
const CustomerOrder = lazy(
  () => import("./Order-management/CustomerOrder/index")
);
const CustomerOrderHistory = lazy(
  () => import("./Order-management/CustomerOrderHistory/index")
);
const CustomerOrderHistoryEdit = lazy(
  () =>
    import("./Order-management/CustomerOrderHistory/CustomerOrderHistoryEdit")
);
const DispatchBoardList = lazy(
  () => import("./Order-management/DispatchBoard/index")
);
const UploadBulkQuote = lazy(
  () => import("./Order-management/BulkUploadQuote/index")
);
const UploadBulkOrder = lazy(
  () => import("./Order-management/BulkUploadOrder/index")
);
const BulkOrderProcess = lazy(
  () => import("./Order-management/BulkOrderProcess/Index")
);
const BulkQuoteProcess = lazy(
  () => import("./Order-management/BulkQuoteProcess/Index")
);
const BilledOrderHistory = lazy(
  () => import("./Order-management/BilledOrderHistory/index")
);
const ViewBilledOrderHistory = lazy(
  () => import("./Order-management/BilledOrderHistory/ViewBilledOrderHistory")
);

// Api Management
const AgentApi = lazy(() => import("./api-management/AgentApi/index"));
const XcelaratorApi = lazy(
  () => import("./api-management/XcelaratorApi/index")
);
const AddEditXcelaratorApi = lazy(
  () => import("./api-management/XcelaratorApi/AddEditXcelaratorApi")
);
const AddEditXcelaratorApiTabs = lazy(
  () => import("./api-management/XcelaratorTabs/index")
);
const AddAgentApi = lazy(() => import("./api-management/AgentApi/AddAgentApi"));
// Account managenet
const InvoiceGroups = lazy(
  () => import("./account-management/GroupInvoice/index")
);
const AddEditInvoiceGroups = lazy(
  () => import("./account-management/GroupInvoice/AddEditInvoiceGroups")
);
const InvoiceManagement = lazy(
  () => import("./account-management/Invoice/Index")
);
const AddEditOrderInvoice = lazy(
  () => import("./account-management/Invoice/AddEditOrderInvoice")
);
const FinalizedOrders = lazy(
  () => import("./account-management/Accounting/Index")
);
//Report
const CreateReport = lazy(() => import("./report/CreateReport/index"));
const SavedReports = lazy(() => import("./report/SavedReports/index"));

// Settings
const SettingsAdditionalCharges = lazy(
  () => import("./settings/AdditionalCharges")
);
const AddEditSettingsAdditionalCharges = lazy(
  () => import("./settings/AdditionalCharges/AddEditSettingsAdditionalCharges")
);
const PackageTypeList = lazy(() => import("./settings/PackageType/index"));
const EmailTemplate = lazy(
  () => import("./service-config/EmailTemplate/index")
);
const AddNewEmailTemplate = lazy(
  () => import("./service-config/EmailTemplate/addNewTemplate")
);

const EmailConfig = lazy(
  ()=> import("./service-config/EmailConfig/EmailConfig")
);

const RegionListing= lazy(
  ()=> import("./service-config/Region/RegionListing")
);

const FscLocationListing = lazy(
  () => import("./service-config/FscLocation/FscLocationListing")
);

const MasterZipCode = lazy(
  () => import("./service-config/MasterZipCode/index")
);

const Mailboxes = lazy(() => import("./service-config/Mailboxes/index"));

const GroupsAssignment = lazy(() => import("./service-config/GroupsAssignment/index"));

const SlaPolicies = lazy(() => import("./service-config/SlaPolicies/index"));

const BusinessHours = lazy(() => import("./service-config/BusinessHours/index"));

const SignaturesSending = lazy(() => import("./service-config/SignaturesSending/index"));

const HelpdeskNotifications = lazy(() => import("./service-config/Notifications/index"));

const TicketFieldsStatuses = lazy(() => import("./service-config/TicketFieldsStatuses/index"));

const HelpdeskTags = lazy(() => import("./service-config/Tags/index"));

const CannedResponses = lazy(() => import("./service-config/CannedResponses/index"));

// Communications
const TicketQueue = lazy(() => import("./communications/TicketQueue/index"));
const TicketDetail = lazy(() => import("./communications/TicketDetail/index"));

// Audit Log
const AuditLog = lazy(() => import("./audit-log/index"));

export {
  //CustomerMarkupList,
  //AddEditCustomerMarkup,
  Home,
  Login,
  ForgotPassword,
  Profile,
  AddUser,
  ChangePassword,
  UserList,
  Prior,
  Customers,
  AddCustomer,
  CustomerUsers,
  AddEditCustomerUsers,
  AgentList,
  AgentRequestList,
  AddEditAgentRequest,
  AgentRate,
  AddEditAgentList,
  AgentListTabs,
  MasterAgentList,
  MasterAgentListTabs,
  AgentHubs,
  AddEditAgentHub,
  AgentDocList,
  MyRepList,
  AddEditSalesRep,
  CustomerOrder,
  CustomerOrderHistory,
  CustomerOrderHistoryEdit,
  DispatchBoardList,
  BilledOrderHistory,
  ViewBilledOrderHistory,
  AgentApi,
  XcelaratorApi,
  AddEditXcelaratorApi,
  AddEditXcelaratorApiTabs,
  AddCustomerOfCustomer,
  CustomerRate,
  EmailNotificationPermissions,
  InvoiceGroups,
  AddEditInvoiceGroups,
  InvoiceManagement,
  AddEditOrderInvoice,
  CreateReport,
  SavedReports,
  SettingsAdditionalCharges,
  AddEditSettingsAdditionalCharges,
  AddEditAgentAdditionalCharges,
  AddEditCustomerAdditionalCharges,
  AddEditCustomerInvoiceGroups,
  FinalizedOrders,
  AddAgentApi,
  PackageTypeList,
  EmailTemplate,
  EmailConfig,
  RegionListing,
  AddNewEmailTemplate,
  UploadBulkQuote,
  UploadBulkOrder,
  BulkOrderProcess,
  BulkQuoteProcess,
  //TrackOrder
  CustomerAddress,
  CustomerAddressAdd,
  // Providence Location List
  ProvidenceLocationList,
  AddEditLocation,
  FscLocationListing,
  MasterZipCode,
  Mailboxes,
  GroupsAssignment,
  SlaPolicies,
  BusinessHours,
  SignaturesSending,
  HelpdeskNotifications,
  TicketFieldsStatuses,
  HelpdeskTags,
  CannedResponses,
  TicketQueue,
  TicketDetail,
  AuditLog,
};
